import React from 'react'
import PropTypes from 'prop-types'

import { Card, Typography, Skeleton } from '@chilecompra/react-kit/components'

import { REACT_APP_LAWSUIT_BASE_URL } from '../../../config/settings/environment'

import { Grid, Link } from '../DirectDealSummary.styles'

/**
 * The DirectDealSummary's details lawsuit.
 */
const DirectDealSummaryDetailLawsuit = props => {
  const { lawsuitAmount, loading, sheet } = props

  return (
    <Grid padding="16px 0 0">
      <Card padding="24px 16px" color="blank" enableBorder>
        <Grid container spacing={1}>
          <Grid item>
            {loading ? (
              <>
                <Skeleton width="70%" />
              </>
            ) : (
              <Typography fontWeight="bold" color="black1" variant="body2" tabIndex="0">
                Demandas ante el Tribunal de Contratación Pública
              </Typography>
            )}
          </Grid>
          {lawsuitAmount !== 0 && (
            <Grid item>
              {loading ? (
                <>
                  <Skeleton width="50%" />
                </>
              ) : (
                <Typography color="black1" variant="body2" tabIndex="0">
                  Este Trato Directo ha recibido {lawsuitAmount} demandas ante el{' '}
                  <Link href={REACT_APP_LAWSUIT_BASE_URL.concat(sheet?.code)} target="_blank" rel="noreferrer">
                    Tribunal de Contratación Pública.
                  </Link>
                </Typography>
              )}
            </Grid>
          )}
          {lawsuitAmount === 0 && (
            <Grid item>
              {loading ? (
                <>
                  <Skeleton width="30%" />
                </>
              ) : (
                <Typography color="black1" variant="body2" tabIndex="0">
                  Este Trato Directo no ha recibido demandas ante el Tribunal de Contratación Pública.
                </Typography>
              )}
            </Grid>
          )}
        </Grid>
      </Card>
    </Grid>
  )
}

DirectDealSummaryDetailLawsuit.propTypes = {
  loading: PropTypes.bool,
  sheet: PropTypes.shape({
    code: PropTypes.string
  }),
  lawsuitAmount: PropTypes.number
}

export default DirectDealSummaryDetailLawsuit
